module.exports = __webpack_public_path__ + "img/comment.62b97d1f.svg";